import { createContext } from "react";

const RegimenesFiscalesContext = createContext();

export default RegimenesFiscalesContext;
